import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services';

// Custom toggle component
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
        href=""
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        className="dropdown-toggle"
    >
        {children}
    </a>
));

// Custom menu component with optional search filter
const CustomMenu = React.forwardRef(
    ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
        const [value, setValue] = useState('');

        return (
            <div
                ref={ref}
                style={style}
                className={className}
                aria-labelledby={labeledBy}
            >
                <ul className="list-unstyled">
                    {React.Children.toArray(children).filter(
                        (child) =>
                            !value ||
                            child.props.children
                                .toString()
                                .toLowerCase()
                                .startsWith(value.toLowerCase())
                    )}
                </ul>
            </div>
        );
    }
);

// Main component
const Logout = () => {
    const navigate = useNavigate();
    const userName = localStorage.getItem('email') || 'User'  // e.g., "Rashmi"
    const firstLetter = userName ? userName.charAt(0).toUpperCase() : '';
    const handleLogout = async () => {
        const refresh_token = sessionStorage.getItem('refresh_token')
        try {
            const params = {
                refresh_token: refresh_token
            }
            const response = await logout(params);
            console.log("response logout", response)
            const status = response.statusCode?.response_data?.status_code;

            if (status === 200) {
                sessionStorage.clear();
                navigate('/')
            }
        } catch (err) {
            console.log("err", err)
        }
    };


    return (
        <Dropdown className="cstm_dropdown">
            <Dropdown.Toggle className='font_500' as={CustomToggle} id="dropdown-custom-components">
                {firstLetter ? firstLetter :
                    <img src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/user-profile.svg" alt="user-profile" width="50" height="50" loading='lazy' />}
            </Dropdown.Toggle>

            <Dropdown.Menu as={CustomMenu}>
                <Dropdown.Item eventKey="1">
                    <div className="d-flex font_500 gap-3 align-items-center color_white">
                        <span className='user_name'>
                            {firstLetter}
                        </span>
                        <div className='d-flex font_500 flex-column'>
                            Username
                            <p className='mb-0 user_email'>
                                {userName}
                            </p>
                        </div>
                    </div>
                </Dropdown.Item>
                <Dropdown.Item eventKey="2">
                    <div className="d-flex font_500 gap-4 color_white">
                        <img src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/sparkles.svg" alt="sparkles" height={24} width={21} loading='lazy' />
                        Upgrade Now!
                    </div>
                </Dropdown.Item>
                <Dropdown.Item eventKey="3" href='/settings'>
                    <div className="d-flex font_500 gap-4 color_white">
                        <img src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/user-profile.svg" alt="user-profile" height={24} width={21} loading='lazy' />
                        Profile
                    </div>
                </Dropdown.Item>
                <Dropdown.Item eventKey="4" href='/settings'>
                    <div className="d-flex font_500 gap-4 color_white">
                        <img src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/user-setting.svg" alt="user-setting" height={24} width={21} loading='lazy' />
                        Settings
                    </div>
                </Dropdown.Item>
                <Dropdown.Item eventKey="5" onClick={handleLogout}>
                    <div className="d-flex font_500 gap-4 color_white">
                        <img src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/log-out.svg" alt="log-out" height={24} width={21} loading='lazy' />
                        Logout
                    </div>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default Logout;
